require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./~/.deno/core-js@2.6.12/~/core-js/library/modules/es7.symbol.observable.js
// module id = 230
// module chunks = 0